var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTimeCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M18 9C18 13.9716 13.9707 18 9 18C4.0293 18 0 13.9716 0 9C0 4.0302 4.0293 0 9 0C13.9707 0 18 4.0302 18 9Z",
    fill: "#FF862F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2153 12.4327C12.0974 12.4327 11.9786 12.4021 11.8697 12.3382L8.33631 10.2304C8.13291 10.108 8.00781 9.88752 8.00781 9.64992V5.10762C8.00781 4.73502 8.31021 4.43262 8.68281 4.43262C9.05541 4.43262 9.35781 4.73502 9.35781 5.10762V9.26652L12.5618 11.1772C12.8813 11.3689 12.9866 11.7829 12.7958 12.1033C12.6689 12.3148 12.4448 12.4327 12.2153 12.4327Z",
    fill: "#FF862F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTimeCircle);
export default __webpack_public_path__ + "static/media/icon-time-circle.09b56b1662f4e93cf4577136ef293135.svg";
export { ForwardRef as ReactComponent };